import { useEffect } from 'react'
import Entity from '../types/Entity'

interface useOnIncludedRowsChangeProps {
  includedRows: Array<Entity>
  onIncludedRowsChange?: (rows: Entity[]) => void
}

const useOnIncludedRowsChange = (props: useOnIncludedRowsChangeProps) => {
  useEffect(() => {
    props.onIncludedRowsChange?.(props.includedRows)
  }, [props.includedRows])
}

export default useOnIncludedRowsChange
